import {defineAsyncComponent} from 'vue';

const CommuneBudgetComparison = defineAsyncComponent(() =>
  import('@/views/settlementInstructions/communeBudgetComparison/CommuneBudgetComparison.vue'),
);

export function registerSettlementInstruction(app) {
  app.component('CommuneBudgetComparison', CommuneBudgetComparison);
}
